import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WowInit from "../../components/wowInit/wowInit";

// ✅ Home Pages
import Homepage from "../HomePage";
import AboutPage from "../AboutPage/AboutPage";
import ServicePage from "../ServicePage/ServicePage";
import SeviceSinglePage from "../SeviceSinglePage/SeviceSinglePage";

// ✅ Individual Service Pages
import AIAgentsPage from "../ServicePages/AIAgentsPage";
import GenerativeAIPage from "../ServicePages/GenerativeAIPage";
import AIWebScrapingPage from "../ServicePages/AIWebScrapingPage";
import MachineLearningPage from "../ServicePages/MachineLearningPage";
import LegacyModernizationPage from "../ServicePages/LegacyModernizationPage";
import ContractHiringPage from "../ServicePages/ContractHiringPage";
import WebPortalDevelopmentPage from "../ServicePages/WebPortalDevelopmentPage";
import SystemIntegrationPage from "../ServicePages/SystemIntegrationPage";
import EcommerceWebsitePage from "../ServicePages/EcommerceWebsitePage";
import BusinessWebsitesPage from "../ServicePages/BusinessWebsitesPage";
import BrandingPage from "../ServicePages/BrandingPage";
import CloudMigrationPage from "../ServicePages/CloudMigrationPage";
import EmailMigrationPage from "../ServicePages/EmailMigrationPage";
import SoftwareMaintenancePage from "../ServicePages/SoftwareMaintenancePage";
import MobileAppDevelopmentPage from "../ServicePages/MobileAppDevelopmentPage";
import ARVRDevelopmentPage from "../ServicePages/ARVRDevelopmentPage";
import GraphicDesigningPage from "../ServicePages/GraphicDesigningPage";

// ✅ Solution Pages
import HybridCloudPage from "../SolutionPages/HybridCloudPage";
import PrivateCloudPage from "../SolutionPages/PrivateCloudPage";
import ManagedCloudPage from "../SolutionPages/ManagedCloudPage";
import CloudConsultingPage from "../SolutionPages/CloudConsultingPage";
import AWSServicesPage from "../SolutionPages/AWSServicesPage";
import HRPayrollPage from "../SolutionPages/HRPayrollPage";
import ManufacturingERPPage from "../SolutionPages/ManufacturingERPPage";
import CRMPage from "../SolutionPages/CRMPage";
import SupplyChainPage from "../SolutionPages/SupplyChainPage";
import WhatsAppAIBotsPage from "../SolutionPages/WhatsAppAIBotsPage";
// import SMSPage from "../SolutionPages/SMSPage";
// import EmailPage from "../SolutionPages/EmailPage";
// import VoicePage from "../SolutionPages/VoicePage";
import DomainManagementPage from "../SolutionPages/DomainManagementPage";
import DNSPage from "../SolutionPages/DNSPage";
// import DigitalSigningPage from "../SolutionPages/DigitalSigningPage";

// ✅ Other Pages
import CareerSection from "../CareerSection/CareerSection";
import CareerDetails from "../CareerDetails/CareerDetails";
import ProjectPage from "../ProjectPage/ProjectPage";
import ProjectDetails from "../ProjectDetails/ProjectDetails";
import ScrollToTop from "./ScrollToTop";
import BlogPage from "../BlogPage/BlogPage";
import BlogDetails from "../BlogDetails/BlogDetails";
import ContactPage from "../ContactPage/ContactPage";
import ErrorPage from "../ErrorPage/ErrorPage";
import CSRPage from "../CSRPage/CSRPage";

// ✅ Legal Pages
import PrivacyPolicyPage from "../LegalPages/PrivacyPolicyPage";
import TermsOfServicePage from "../LegalPages/TermsOfServicePage";
import RefundPolicyPage from "../LegalPages/RefundPolicyPage";

// ✅ Router Component
const AllRoute: React.FC = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <WowInit />
        <ScrollToTop />

        <Routes>
          {/* ✅ Home Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/services" element={<ServicePage />} />
          <Route path="/service-details/:slug" element={<SeviceSinglePage />} />
          <Route path="/service-details" element={<SeviceSinglePage />} />

          {/* ✅ Individual Service Pages */}
          <Route path="/services/ai-agents" element={<AIAgentsPage />} />
          <Route path="/services/generative-ai" element={<GenerativeAIPage />} />
          <Route path="/services/ai-web-scraping" element={<AIWebScrapingPage />} />
          <Route path="/services/machine-learning" element={<MachineLearningPage />} />
          <Route path="/services/legacy-modernization" element={<LegacyModernizationPage />} />
          <Route path="/services/contract-hiring" element={<ContractHiringPage />} />
          <Route path="/services/web-portal-development" element={<WebPortalDevelopmentPage />} />
          <Route path="/services/system-integration" element={<SystemIntegrationPage />} />
          <Route path="/services/ecommerce-website" element={<EcommerceWebsitePage />} />
          <Route path="/services/business-websites" element={<BusinessWebsitesPage />} />
          <Route path="/services/branding" element={<BrandingPage />} />
          <Route path="/services/cloud-migration" element={<CloudMigrationPage />} />
          <Route path="/services/email-migration" element={<EmailMigrationPage />} />
          <Route path="/services/software-maintenance" element={<SoftwareMaintenancePage />} />
          <Route path="/services/mobile-app-development" element={<MobileAppDevelopmentPage />} />
          <Route path="/services/ar-vr-development" element={<ARVRDevelopmentPage />} />
          <Route path="/services/graphic-designing" element={<GraphicDesigningPage />} />

          {/* ✅ Solution Pages */}
          <Route path="/solutions/hybrid-cloud" element={<HybridCloudPage />} />
          <Route path="/solutions/private-cloud" element={<PrivateCloudPage />} />
          <Route path="/solutions/managed-cloud" element={<ManagedCloudPage />} />
          <Route path="/solutions/cloud-consulting" element={<CloudConsultingPage />} />
          <Route path="/solutions/aws-services" element={<AWSServicesPage />} />
          <Route path="/solutions/hr-payroll" element={<HRPayrollPage />} />
          <Route path="/solutions/manufacturing-erp" element={<ManufacturingERPPage />} />
          <Route path="/solutions/crm" element={<CRMPage />} />
          <Route path="/solutions/supply-chain" element={<SupplyChainPage />} />
          <Route path="/solutions/whatsapp-ai-bots" element={<WhatsAppAIBotsPage />} />
          {/* <Route path="/solutions/sms" element={<SMSPage />} /> */}
          {/* <Route path="/solutions/email" element={<EmailPage />} /> */}
          {/* <Route path="/solutions/voice" element={<VoicePage />} /> */}
          <Route path="/solutions/domain-management" element={<DomainManagementPage />} />
          <Route path="/solutions/dns" element={<DNSPage />} />
          {/* <Route path="/solutions/digital-signing" element={<DigitalSigningPage />} /> */}

          {/* ✅ Other Pages */}
          <Route path="/careers" element={<CareerSection />} />
          <Route path="/career-details" element={<CareerDetails />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/corporate-social-responsibility" element={<CSRPage />} />

          {/* ✅ Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />

          {/* ✅ Error Page */}
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;

